import { ObjectType } from "./object-type";

export enum NamingRuleContext {
  Asset = "Asset",
  Order = "Order",
}

export class DbMetadataNamingRuleInfos {
  id: number | null = 0;
  platformId: number | null = null;
  objectType: ObjectType | null = null;
  context: NamingRuleContext | null = null;
  contentSubType: string | null = null;
  rules: string[] | null = null;

  constructor(init?: Partial<DbMetadataNamingRuleInfos>) {
    Object.assign(this, init);
  }
}
